import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Parse a UTC timestamp from the API.
 * MongoDB strips timezone info, so timestamps come back without 'Z'.
 * This ensures JavaScript treats them as UTC, not local time.
 */
export function utcDate(timestamp) {
  if (!timestamp) return null;
  const str = String(timestamp);
  if (str.endsWith('Z') || str.includes('+') || str.includes('-', 10)) {
    return new Date(str);
  }
  return new Date(str + 'Z');
}
